import React, { useContext, useEffect, useState } from 'react';
import { View, TouchableOpacity } from 'react-native';
import _ from 'lodash';
import styled from 'styled-components/native';
import { FlexBlockWrapped, FlexBlock, FlexElement, MetricStackTitle, ShinyBlockOuter, ShinyBody, ShinyHeading, BasicText as Text, Heading4, Button, ExtraStyles, BasicText, ModalSubmitButton, Heading3 } from '../../Styles';
import { Icon } from '../..';
import Modal, { ModalContext } from '../../core/Modal';
import MoreInformation from './ProgramMoreInformation';
import WasteBrand from '../../../WasteTheme';
import Util from '../../core/Util';

const ProgramWrapper = styled(FlexBlock)`
    justify-content: flex-start;
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const ProgramBlock = styled(TouchableOpacity)`
    justify-content: space-between;
    align-items: center;
    color: #949492;
    border-width: 1px;
    border-color: ${props=> props.borderColour? props.borderColour : "#d8d8d8"};
    flex: 1;
    flex-basis: ${props => props.isMobile && props.isMobile()? "143px" : "170px"};
    flex-grow: 0;
    margin: 10px;
`;

const BlockHeading = styled(View)`
    flex-direction: row;
    height: 40px;
    width: 100%;
    justify-content: space-evenly;
    align-items: center;
    color: #FFFFFF;
    background-color: ${props => props.colour ? props.colour : "white"};
`;

const IconChunk = styled.View`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-grow: 0;
    justify-content: space-between;
    margin-top: 20px;
    margin-bottom: 10px;
    width: 100%;
`;

const ProgramOuter = ({children = undefined, modalChildren, borderColour = undefined, style = undefined})=>{
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    useEffect(()=>{
        if(modalVisible == false){
            setModalContent(null);
        }
    }, [modalVisible]);

    const pressEvent = () => {
        setModalContent(modalChildren);
        setModalVisible(true);
    }
    
    return <ProgramBlock onPress={pressEvent} borderColour={borderColour} style={style} isMobile={Util.isMobile}>
        <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
            {modalContent}
        </Modal>
        {children}
    </ProgramBlock>;
}

const Program = ({children = undefined, colour, title, icon, height, modalChildren, helpIcon = undefined, iconSize = undefined}) =>{
    return <ProgramOuter modalChildren={modalChildren}>
        <BlockHeading colour={colour}>
            <Heading4 colour={"#FFFFFF"} align="center">{title}</Heading4>
            {helpIcon}
        </BlockHeading>
        <IconChunk style={{height: height}}>
            <Icon icon={icon} colour={colour} size={iconSize}/>
            {children}
        </IconChunk>
    </ProgramOuter>
}

const AdditionalProgramDescription = ({children, site, allPrograms, program}) => {
    const modalContext = useContext(ModalContext);
    
    const [modalVisible, setModalVisible] = useState(false);
    const [modalContent, setModalContent] = useState(null);

    useEffect(()=>{
        if(modalVisible == false){
            setModalContent(null);
        }
    }, [modalVisible]);

    const pressEvent = () => {
        modalContext.updateChildren(<MoreInformation site={site} allPrograms={allPrograms} defaultSelected={[program]}/>);
    }

    return <View>
        <Modal modalVisible={modalVisible} setModalVisible={setModalVisible}>
            {modalContent}
        </Modal>
        <Heading3>{program.label}</Heading3>
        <Text align="center">{children}</Text>
        <ModalSubmitButton onPress={pressEvent} theme={WasteBrand}>More Information</ModalSubmitButton>
    </View>;
}

const ProgramsContainer = ({ children, title, extraChildren = undefined, badgeHeight = undefined, colour = undefined, site = undefined, allPrograms = []}) => {
    const moreInfoMarginTop = 5;

    const programs = _.map(children, (program) => {

        if(program.hideIcon == true){
            return <ProgramOuter key={program.icon} modalChildren={program.detailedDescription} style={ExtraStyles.buttonLight}>
                <Icon icon={program.icon} size={15}/>
                <Text>{program.label}</Text>
                <Icon icon="long-arrow-right" size={15}/>
            </ProgramOuter>;
        }

        return <Program 
            key={program.icon} 
            colour={colour || WasteBrand.brandColor}
            icon={program.icon}
            iconSize={30}
            height={(program.height || badgeHeight) + moreInfoMarginTop} 
            title={program.label} 
            modalChildren={<AdditionalProgramDescription site={site} allPrograms={allPrograms} program={program}>{program.detailedDescription}</AdditionalProgramDescription>}
        >
            <View style={{flexDirection: "row", justifyContent: "space-between", alignItems: "center", width: "50%", marginTop: moreInfoMarginTop}}><Text>More Info</Text><Icon icon="long-arrow-right" size={15}/></View>
        </Program>;
    });

    return <ShinyBlockOuter flexBasis={"95%"}>
        <ShinyHeading>
            <MetricStackTitle>{title}</MetricStackTitle>
        </ShinyHeading>
        <ShinyBody>
            <ProgramWrapper>
                {extraChildren}
                {programs}
            </ProgramWrapper>
        </ShinyBody>
    </ShinyBlockOuter>;
}

const Programs = ({site, services, badgeHeight = undefined}) => {
    const allPrograms = [];
    const enrolled = [];
    const additional = [];
    
    _.forEach(_.keys(site.value_add_programs), (programKey)=>{
        if(programKey == "garbage"){
            return;
        }
        
        if(site.value_add_programs[programKey].value == true){
            enrolled.push(site.value_add_programs[programKey]);
        } else {
            additional.push(site.value_add_programs[programKey]);
        }

        allPrograms.push(site.value_add_programs[programKey]);
    });

    const moreInformation = {
        icon: "question",
        label: "Questions",
        hideIcon: true,
        border: "none",
        height: 40,
        detailedDescription: ()=>{
            return <MoreInformation site={site} allPrograms={allPrograms} />
        }
    }

    additional.push(moreInformation);

    return <>
        <ProgramsContainer title="Current Managed Services" extraChildren={services} badgeHeight={badgeHeight} site={site} allPrograms={allPrograms}>{enrolled}</ProgramsContainer>
        <ProgramsContainer title="Available Services" badgeHeight={badgeHeight} colour={"#707070"} site={site} allPrograms={allPrograms}>{additional}</ProgramsContainer>
    </>;
}

export { Program };
export default Programs;